import React from "react";
import { isProbablyHtmlString } from "../../utils/previewUtils";

/**
 * Renders short_description from API/snapshot: HTML from Lexical/editor as markup, plain text as pre-wrap.
 */
export default function HtmlOrPlainShortDescription({ value, style, className }) {
  if (value == null || value === "") return null;
  const s = String(value);
  if (isProbablyHtmlString(s)) {
    return (
      <div
        className={className}
        style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
          ...style,
        }}
        dangerouslySetInnerHTML={{ __html: s }}
      />
    );
  }
  return (
    <div className={className} style={{ whiteSpace: "pre-wrap", ...style }}>
      {s}
    </div>
  );
}
